const Circle = (props?: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8333 8.01064C12.8333 8.64536 12.7083 9.27387 12.4654 9.86028C12.2225 10.4467 11.8665 10.9795 11.4177 11.4283C10.9689 11.8771 10.436 12.2332 9.84964 12.4761C9.26323 12.719 8.63473 12.844 8.00001 12.844C7.36528 12.844 6.73678 12.719 6.15037 12.4761C5.56396 12.2332 5.03114 11.8771 4.58232 11.4283C4.13351 10.9795 3.77748 10.4467 3.53459 9.86028C3.29169 9.27387 3.16667 8.64536 3.16667 8.01064C3.16667 6.72876 3.6759 5.49938 4.58232 4.59296C5.48875 3.68653 6.71813 3.17731 8.00001 3.17731C9.28188 3.17731 10.5113 3.68653 11.4177 4.59296C12.3241 5.49938 12.8333 6.72876 12.8333 8.01064Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Circle;
